import { render, staticRenderFns } from "./ConfirmAskChange.vue?vue&type=template&id=0f724f8c&scoped=true&"
import script from "./ConfirmAskChange.vue?vue&type=script&lang=js&"
export * from "./ConfirmAskChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f724f8c",
  null
  
)

export default component.exports